/**
 * Studio API base URL — the origin the typed `@v0y4ge/api-client` hub/landing
 * functions fetch against (they take an explicit `{ baseUrl }`, unlike the
 * apiRaw-based events/locations/dashboard clients which use global config).
 *
 * At deploy, studio-shell injects `window.__STUDIO_API_BASE__`. In the design
 * env (MSW / harness) the empty string means same-origin, which MSW intercepts.
 */
export function getStudioBaseUrl(): string {
  try {
    return (window as { __STUDIO_API_BASE__?: string }).__STUDIO_API_BASE__ || "";
  } catch {
    return "";
  }
}

/** Standard request options for the hub/landing clients. */
export function studioRequestOptions(surface?: string): { baseUrl: string; surface?: string } {
  return { baseUrl: getStudioBaseUrl(), ...(surface ? { surface } : {}) };
}
